var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M0 7a2 2 0 0 1 2-2h10a2 2 0 1 1 0 4H2a2 2 0 0 1-2-2"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 4,
  x: 9,
  fill: "#333",
  rx: 2,
  transform: "rotate(90 9 0)"
})));
export default SvgPlus;